module.exports = __webpack_public_path__ + "media/images/admin/icons/search-f9705ffe407455bd10ed6827af98d123.svg";